<template>
    <div>
        <div v-if="loading" class="col-md-12 text-center" style="margin-top:25%">
            <PulseLoader :loading="loading"></PulseLoader>
        </div>
        <div v-if="!loading">
            <div class="row">
                <div class="col-md-12 col-sm-12 ">
                    <div class="">
                        <div class="x_panel">
                            <h2 class="float-left">KPI for Overall CMMS (Comparison between target and actual)</h2>
                            <ul class="nav navbar-right panel_toolbox">
                                <li>
                                    <button class="btn btn-warning btn-sm float-right" onclick="window.print()"><i class="fa fa-print"></i> Print</button>
                                </li>
                                <li>
                                    <button class="btn btn-primary btn-sm float-right"><i class="fa fa-file-excel-o"></i> Excel</button>
                                </li>
                                <li>
                                    <button @click="goBack" class="btn btn-danger btn-sm float-right">Back <i class="fa fa-arrow-circle-o-right"></i></button>
                                </li>
                            </ul>
                        </div>

                        <div class="d-flex justify-content-center">
                            <div class="mr-2">
                                <DatePicker type="month" v-model="searchDate" format="MM-YYYY" valueType="format"></DatePicker>
                            </div>
                            <div>
                                <button type="button" class="btn btn-sm btn-info">Search</button>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-12">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="card-box table-responsive">
                                            <p class="text-muted font-13 m-b-30"></p>
                                            <table :class="getTableClasses" style="width:100%">
                                                <thead>
                                                <tr>
                                                    <th rowspan="2">Description</th>
                                                    <th colspan="3">SIP JDA</th>
                                                </tr>
                                                <tr>
                                                    <th>Target</th>
                                                    <th>Actual <br> (May 2025)</th>
                                                    <th>Cumulative <br> (Jan 25 - May 2025)</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr>
                                                    <td>Total Backlog (%) < 10 % 0.33% 0.13%
                                                        (Open + Completed+in progress) / Total WO*) x 100
                                                        *(Total work order that has to target complete data for the reporting month + backlog carried over from last month.) 1/(298+6)
                                                    </td>
                                                    <td><=10%</td>
                                                    <td>0.33%</td>
                                                    <td>0.13%</td>
                                                </tr>
                                                <tr>
                                                    <td>Total Backlog (%) < 10 % 0.33% 0.13%
                                                        (Open + Completed+in progress) / Total WO*) x 100
                                                        *(Total work order that has to target complete data for the reporting month + backlog carried over from last month.) 1/(298+6)
                                                    </td>
                                                    <td><=10%</td>
                                                    <td>0.33%</td>
                                                    <td>0.13%</td>
                                                </tr>
                                                <tr>
                                                    <td>Total Backlog (%) < 10 % 0.33% 0.13%
                                                        (Open + Completed+in progress) / Total WO*) x 100
                                                        *(Total work order that has to target complete data for the reporting month + backlog carried over from last month.) 1/(298+6)
                                                    </td>
                                                    <td><=10%</td>
                                                    <td>0.33%</td>
                                                    <td>0.13%</td>
                                                </tr>
                                                <tr>
                                                    <td>Total Backlog (%) < 10 % 0.33% 0.13%
                                                        (Open + Completed+in progress) / Total WO*) x 100
                                                        *(Total work order that has to target complete data for the reporting month + backlog carried over from last month.) 1/(298+6)
                                                    </td>
                                                    <td><=10%</td>
                                                    <td>0.33%</td>
                                                    <td>0.13%</td>
                                                </tr>
                                                <tr>
                                                    <td>Total Backlog (%) < 10 % 0.33% 0.13%
                                                        (Open + Completed+in progress) / Total WO*) x 100
                                                        *(Total work order that has to target complete data for the reporting month + backlog carried over from last month.) 1/(298+6)
                                                    </td>
                                                    <td><=10%</td>
                                                    <td>0.33%</td>
                                                    <td>0.13%</td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import moment from 'moment';
    import DatePicker from 'vue2-datepicker'
    import 'vue2-datepicker/index.css'
    import auth from '@/auth.js'
    import PulseLoader from "vue-spinner/src/PulseLoader.vue";
    import Pagination from "@/components/Pagination/Pagination.vue";
    import permissionsMixin from "@/mixin/permissionsMixin";
    import printMixin from "@/mixin/printMixin";
    import goBackButtonMixin from "@/mixin/goBackButtonMixin";

    export default {
        name: 'OverallCMMSKPI',
        components: {Pagination, DatePicker, PulseLoader},
        mixins: [permissionsMixin, printMixin, goBackButtonMixin],
        data() {
            return {
                loading: false,
                appName: process.env.VUE_APP_NAME,
                vesselName: auth.getVesselName(),
                permissions: auth.getPermissionData(),
                vessel_id: auth.getVesselId(),
                searchDate: moment().format('MM-YYYY')
            }
        },
        mounted() {
        },
        computed: {
            getTableClasses() {
                return {
                    'table': true,
                    'text-center': true,
                    'table-striped': !this.isPrinting,
                    'table-bordered': !this.isPrinting,
                    'table-sm': !this.isPrinting,
                    'print-table': this.isPrinting,
                    'vertical-align-middle': true
                };
            }
        },
        methods: {
            goBack() {
                this.$router.go(-1);
            }
        }
    }
</script>

<style scoped>
    .table thead th {
        background-color: #ffbf00;
        color: #0f0f0f !important;
    }
</style>
